var map = {
	"./en/common.json": [
		4749,
		749
	],
	"./en/customer.json": [
		4280,
		280
	],
	"./en/dynamic.json": [
		2237,
		237
	],
	"./en/menu.json": [
		6103,
		103
	],
	"./en/message.json": [
		8287,
		287
	],
	"./en/notification.json": [
		3543,
		543
	],
	"./en/report.json": [
		910,
		910
	],
	"./en/translation.json": [
		3219,
		219
	],
	"./en/user.json": [
		9659,
		659
	],
	"./th/common.json": [
		1244,
		244
	],
	"./th/customer.json": [
		7725,
		725
	],
	"./th/dynamic.json": [
		1410,
		410
	],
	"./th/menu.json": [
		8342,
		342
	],
	"./th/message.json": [
		5868,
		868
	],
	"./th/notification.json": [
		5829,
		210
	],
	"./th/report.json": [
		9467,
		467
	],
	"./th/translation.json": [
		9572,
		572
	],
	"./th/user.json": [
		5822,
		822
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4766;
module.exports = webpackAsyncContext;